import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    useMediaConfigReel,
    useDictionary,
} from 'bdvp-common/src/hooks/config';

import COLORS from '@mlb/react-patterns/style/universal.color';

const Container = styled.p`
    margin: 0;
    font-size: 15px;
    color: ${COLORS.mlbGrey2};
    line-height: 1.3;
`;

const Instructions = (props) => {

    const {
        isEmpty,
        className,
    } = props;


    const config = useMediaConfigReel();
    const { creation = {} } = config;
    const {
        create_reel_instructions_empty: createReelInstructionsEmpty = 'Search for highlights. Choose up to {{maxClips}} videos for your reel. Create and share with friends.',
        create_reel_instructions: createReelInstructions = 'Put the finishing touches on your reel by reordering your clips.',
    } = useDictionary();

    const maxClips = creation.maxClips ?? 10;

    return (
        <Container className={className}>
            {isEmpty
                ? createReelInstructionsEmpty.replace('{{maxClips}}', maxClips)
                : createReelInstructions
            }
        </Container>
    );

};

Instructions.propTypes = {
    isEmpty: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

Instructions.defaultProps = {
    className: undefined,
};

export default Instructions;
